type UnaryFunction = (value: any) => any;

export function compose(...functions: UnaryFunction[]) {
  return (value: unknown) => functions.reduceRight((result, fn) => fn(result), value);
}
